import { useState, useEffect } from 'react';
import { getFile } from '../../../../services/api/files';
import { useNavigate } from 'react-router-dom';
import { Card } from 'antd';
import AccionaLogo from '../../../../style/img/logo.png';
import styles from './index.module.scss';
import { PropTypes } from 'prop-types';
import Project from '../../../../models/Project';
import AccionaIcon from '../../../../components/AccionaIcon';
import { useIntl } from 'react-intl';
import AccionaSpinner from '../../../../components/AccionaSpinner';

const { cardHeader, projectData, card, editIcon, uteImageWrapper } = styles;

const ProjectCard = ({ project, allowEditing }) => {
  const intl = useIntl();
  const [projectImage, setProjectImage] = useState();
  const [uteImage, setUteImage] = useState();
  const [loadingProjectImage, setLoadingProjectImage] = useState(true);
  const [loadingUteImage, setLoadingUteImage] = useState(true);

  useEffect(() => {
    const getImages = async () => {
      if (project.project_image) {
        setLoadingProjectImage(true);
        await getFile('projects-image', project.project_image)
          .then((value) => {
            setProjectImage(URL.createObjectURL(value.data));
          })
          .catch((error) => {
            console.error(error);
          });
      }

      if (project.ute_image) {
        setLoadingUteImage(true);
        await getFile('projects-image', project.ute_image)
          .then((value) => {
            setUteImage(URL.createObjectURL(value.data));
          })
          .catch((error) => {
            console.error(error);
          });
      }

      setLoadingProjectImage(false);
      setLoadingUteImage(false);
    };

    getImages();
  }, [project.project_image, project.ute_image]);

  const navigate = useNavigate();
  return (
    <div className="col-sm-6 col-md-6">
      <Card
        className={card}
        onClick={() => {
          navigate(`/app/project/${project.id_project}`);
        }}
      >
        <div className={cardHeader}>
          {loadingProjectImage ? (
            <div>
              <AccionaSpinner />
            </div>
          ) : (
            <div
              style={
                projectImage
                  ? {
                      backgroundImage: `url(${projectImage || AccionaLogo})`,
                      backgroundSize: '90%',
                      backgroundPosition: 'left center',
                      backgroundRepeat: 'no-repeat',
                    }
                  : {}
              }
            >
              {!projectImage && (
                <img src={projectImage || AccionaLogo} alt="Work" />
              )}
            </div>
          )}
          <div>
            <div className={uteImageWrapper}>
              {loadingUteImage ? (
                <AccionaSpinner size={12} />
              ) : (
                <img
                  src={uteImage || AccionaLogo}
                  alt="Project/ute"
                  style={{ marginBottom: '20px' }}
                />
              )}
            </div>
            {project.country_code && (
              <img
                src={`${
                  process.env.PUBLIC_URL
                }/images/flags/${project.country_code?.toLowerCase()}.svg`}
                alt={project.country_code}
                style={{ width: '50px', height: '35px' }}
              />
            )}
          </div>
        </div>
        <div className={projectData}>
          <p>{project.name}</p>
          <p>{project.description}</p>
        </div>
        {allowEditing && (
          <AccionaIcon
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              navigate(`/app/project/${project.id_project}/edit`);
            }}
            classIcon="icon fas fa-pencil-alt"
            className={editIcon}
            toolTip={intl.formatMessage({ id: 'projects.edit.tooltip' })}
          />
        )}
      </Card>
    </div>
  );
};

ProjectCard.propTypes = {
  project: PropTypes.instanceOf(Project).isRequired,
  allowEditing: PropTypes.bool.isRequired,
};

ProjectCard.defaultProps = {
  allowEditing: false,
};

export default ProjectCard;
